var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/ green / cross") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/-green-/-cross",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(13.000000, 13.000000)",
    fill: "#02339c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9510588,11.4531765 L22.1854118,2.21882353 C22.5990588,1.80517647 22.5990588,1.13458824 22.1854118,0.720941176 C21.7717647,0.307294118 21.1011765,0.307294118 20.6875294,0.720941176 L11.4531765,9.95529412 L2.21882353,0.722352941 C1.80517647,0.308705882 1.13458824,0.308705882 0.720941176,0.722352941 C0.307294118,1.136 0.307294118,1.80658824 0.720941176,2.22023529 L9.95529412,11.4545882 L0.722352941,20.6875294 C0.308705882,21.1011765 0.308705882,21.7717647 0.722352941,22.1854118 C0.929882353,22.3915294 1.19952941,22.496 1.47058824,22.496 C1.74164706,22.496 2.01270588,22.3929412 2.21882353,22.1854118 L11.4531765,12.9510588 L20.6875294,22.1854118 C20.8950588,22.3915294 21.1647059,22.496 21.4357647,22.496 C21.7068235,22.496 21.9778824,22.3929412 22.184,22.1854118 C22.5976471,21.7717647 22.5976471,21.1011765 22.184,20.6875294 L12.9510588,11.4531765 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.b3f64a4631633ced672e02e3e78da0c5.svg";
export { ForwardRef as ReactComponent };